import { useState, FormEvent } from 'react';
import { Container, Paper, Title, TextInput, PasswordInput, Button, Stack, Alert, Text } from '@mantine/core';

export interface LoginPageProps {
  onSubmit: (username: string, password: string) => Promise<void>;
  error: string | null;
  loading: boolean;
}

export function LoginPage({ onSubmit, error, loading }: LoginPageProps) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    try { await onSubmit(username, password); } catch { /* error handled by parent */ }
  }

  return (
    <Container size="xs" py="xl">
      <Paper p="xl" shadow="md" radius="md" withBorder>
        <Stack>
          <Title order={2}>MediaConnect Router</Title>
          <Text c="dimmed" size="sm">Sign in to continue</Text>
          <form onSubmit={handleSubmit}>
            <Stack>
              <TextInput required label="Email" type="email" value={username} onChange={(e) => setUsername(e.currentTarget.value)} disabled={loading} autoComplete="username" />
              <PasswordInput required label="Password" value={password} onChange={(e) => setPassword(e.currentTarget.value)} disabled={loading} autoComplete="current-password" />
              {error && <Alert color="red" variant="light">{error}</Alert>}
              <Button type="submit" loading={loading} fullWidth>Sign in</Button>
            </Stack>
          </form>
        </Stack>
      </Paper>
    </Container>
  );
}
